<template>
  <div
    class="z-100 flex flex-col pb-xs pt-xs bg-whiteOverride absolute shadow-contextMenu min-w-contextMenuMinWidth max-w-contextMenuMaxWidth rounded"
    data-test="context-menu"
  >
    <button
      v-for="( button, key ) in buttons"
      :key="key"
      :disabled="button.isDisabled"
      class="disabled:text-disabledGrey disabled:cursor-auto flex items-center bg-whiteOverride hover:bg-greyHover h-menuItem text-left text-darkFont pl-base border-none cursor-pointer"
      :data-test="`context-menu-${key}`"
      @click="buttonAction(key)"
    >
      <FontIcon
        :name="`${button.icon}`"
        :data-test="`context-menu-icon-${button.icon}`"
      />
      <span class="ml-sm">
        {{ button.label }}
      </span>
    </button>
  </div>
</template>

<script>
import FontIcon from '@/components/Icon.vue';

export default {
  name: 'ContextMenu',
  components: {
    FontIcon,
  },
  props: {
    buttons: {
      type: Object,
      required: true,
    },
  },
  methods: {
    buttonAction(action) {
      this.$emit(`${action}`);
      this.$emit('closeContextMenu');
    },
  },
};
</script>
